package net.bothosting.docs.components.widgets

// Generated by generateNavStructure task
val navStructure = listOf(
    NavSection("Create a Discord Bot", listOf(
        NavItem("How To", "/create_a_discord_bot/how-to"),
    )),
    NavSection("Hosting in Bot-hosting.net", listOf(
        NavItem("Create An Account", "/hosting_in_bot_hosting_net/create-an-account"),
        NavItem("Coin System Explained", "/hosting_in_bot_hosting_net/coin-system-explained"),
        NavItem("Create A Server", "/hosting_in_bot_hosting_net/create-a-server"),
        NavItem("Set Up A Server", "/hosting_in_bot_hosting_net/set-up-a-server"),
        NavItem("Clone A Git Repository On Your Server", "/hosting_in_bot_hosting_net/clone-a-git-repository-on-your-server"),
        NavItem("Connect To Your Servers Files With Sftp", "/hosting_in_bot_hosting_net/connect-to-your-servers-files-with-sftp"),
        NavItem("Link A Domain To Your Server", "/hosting_in_bot_hosting_net/link-a-domain-to-your-server"),
        NavItem("Manage Server Subusers", "/hosting_in_bot_hosting_net/manage-server-subusers"),
    )),
    NavSection("Troubleshooting", listOf(
        NavItem("Cannot Find Module Modulenotfounderror No Such File Or Directory", "/troubleshooting/cannot-find-module-modulenotfounderror-no-such-file-or-directory"),
        NavItem("Upload Unarchive Errors", "/troubleshooting/upload-unarchive-errors"),
        NavItem("Another Power Action Is Currently Being Processed For This Server", "/troubleshooting/another-power-action-is-currently-being-processed-for-this-server"),
        NavItem("Were Having Some Trouble Connecting To Your Server", "/troubleshooting/were-having-some-trouble-connecting-to-your-server"),
        NavItem("An Unexpected Error Was Encountered While Handling This Request", "/troubleshooting/an-unexpected-error-was-encountered-while-handling-this-request"),
        NavItem("The Requested Resource Does Not Exist On This Server", "/troubleshooting/the-requested-resource-does-not-exist-on-this-server"),
        NavItem("Invalid Elf Header", "/troubleshooting/invalid-elf-header"),
        NavItem("Better Sqlite Error", "/troubleshooting/better-sqlite-error"),
        NavItem("Invalid Token Has Been Provided Token Invalid", "/troubleshooting/invalid-token-has-been-provided-token-invalid"),
        NavItem("Request Failed With Status Code 504", "/troubleshooting/request-failed-with-status-code-504"),
        NavItem("Server Rate Limits", "/troubleshooting/server-rate-limits"),
        NavItem("Unknown Interaction", "/troubleshooting/unknown-interaction"),
    )),
    NavSection("FAQs and Info", listOf(
        NavItem("How To Write A Support Request", "/faqs_and_info/how-to-write-a-support-request"),
        NavItem("Can I Create A Free Server", "/faqs_and_info/can-i-create-a-free-server"),
        NavItem("My Server Is Suspended", "/faqs_and_info/my-server-is-suspended"),
        NavItem("Nodes Ip And Information", "/faqs_and_info/nodes-ip-and-information"),
        NavItem("Payment Guide", "/faqs_and_info/payment-guide"),
        NavItem("Issues Creating Server Free Users", "/faqs_and_info/issues-creating-server-free-users"),
        NavItem("Premium Support And Nodes", "/faqs_and_info/premium-support-and-nodes"),
        NavItem("Account Server Recovery", "/faqs_and_info/account-server-recovery"),
        NavItem("Running Installer", "/faqs_and_info/running-installer"),
        NavItem("Why Didnt I Receive Coins After Inviting To Register", "/faqs_and_info/why-didnt-i-receive-coins-after-inviting-to-register"),
        NavItem("Available Server Plans", "/faqs_and_info/available-server-plans"),
        NavItem("Do Not Upload Node Modules", "/faqs_and_info/do-not-upload-node-modules"),
    )),
    NavSection("Community Resources", listOf(
        NavItem("Node And Website Uptime Monitor", "/community_resources/node-and-website-uptime-monitor"),
        NavItem("Bananaburner Panel", "/community_resources/bananaburner-panel"),
        NavItem("Useful Repositories", "/community_resources/useful-repositories"),
    )),
)
